// Launch gates — flip a flag to unlock a path platform-wide. No code deletion.
// Phase 3 (2026-09): Network Contractor RESTORED (founder directive) — the
// existing NC landing/signup/onboarding/portal are live again. Nothing rebuilt.
export const NC_LAUNCH_LOCKED = false;

// 2026-08-24 launch focus (owner directive): the public homepage shows the
// Customer + Provider cards only. Flip these to true to RESTORE the Network
// Contractor / Tools homepage entry points — their routes, pages, components
// and backend systems remain fully intact behind these flags (nothing deleted).
export const HOMEPAGE_SHOW_NC_CARD = true;
export const HOMEPAGE_SHOW_TOOLS_CARD = false;

// Public /tools + /tools/signup entry lock (frontend only — the Tools pages,
// components and backends stay fully intact). Flip to false to relaunch.
export const TOOLS_LAUNCH_LOCKED = true;
